// Re-render Optimization 14.05.2020

import React from 'react'
import moment from 'moment'
import LazyLoad from 'react-lazyload'

import DateLabel from '../../_library/DateLabel'
import Address from '../../_library/Address'

import EventImagePlaceholder from './EventImagePlaceholder'
import { useMediaQuery } from '../../../_common/core/utils'

const EventRowStaff = props => {
  const { event, isHome } = props

  const address = !!event ? event.venue : null
  const organization = !!event ? event.owner.displayName : null
  const { isOnlineEvent } = event

  const startDate = moment(new Date(event.startDate))
  const startDate_utc = moment.utc(new Date(event.startDate))
  const now = new Date()
  const cs = [
    startDate.isBefore(now) ? 'row-stale eventslist-row ' : 'eventslist-row',
    event.pinned ? 'event-pinned' : 'event-unpinned',
  ].join(' ')

  const isMobileHook = useMediaQuery('(max-width: 600px)')
  const isDesktopAndIsHome = !isMobileHook && isHome

  const renderContent = () => (
    <div className={isHome ? 'events-list-item-container' : 'react-table'}>
      {isDesktopAndIsHome ? (
        <div
          id="image-container-big"
          className={isHome ? 'LazyLoad events-list-details-image-container' : 'LazyLoad'}
          style={{ width: '100%', height: '150px', overflow: 'hidden', flexShrink: 0 }}
        >
          <LazyLoad once>
            {!!event.imageURL ? (
              <img
                alt="nodata"
                className={`LazyLoadImg big`}
                src={event.imageURL}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '3px',
                  marginRight: '15px',
                }}
              />
            ) : (
              <EventImagePlaceholder />
            )}
          </LazyLoad>
        </div>
      ) : null}
      <div className={isHome ? 'events-list-details-container' : 'eventslist-thumbs'}>
        <div
          id="image-container-small"
          className={isHome ? 'LazyLoad events-list-details-image-container' : 'LazyLoad'}
          style={
            isDesktopAndIsHome
              ? {
                  display: 'none',
                }
              : {}
          }
        >
          <LazyLoad width={150} height={150} once>
            {!!event.imageURL ? (
              <img
                alt="nodata"
                className={`LazyLoadImg ${isHome ? 'small-mobile' : ''}`}
                src={event.imageURL}
              />
            ) : (
              <EventImagePlaceholder />
            )}
          </LazyLoad>
        </div>
        <div className={isHome ? 'events-list-event-details-block' : 'event-details'}>
          <div className={isHome ? 'brand-details-block' : 'event-brand'}>{organization}</div>
          <div className={isHome ? 'event-name-block' : 'event-name'}>{event.displayName}</div>
          <div className={isHome ? 'event-date-block' : 'event-time'}>
            <img alt="nodata" src={asset('/resources/images/cal-ico.svg')} />
            <DateLabel className="starttime" value={startDate_utc} format="LLL" />
          </div>
          {isOnlineEvent ? (
            <div className={isHome ? 'event-address-block' : 'event-address'}>
              <img alt="nodata" src={asset('/resources/images/location-ico.svg')} />
              <div className="address-notdefined">Online Event</div>
            </div>
          ) : (
            <div className={isHome ? 'event-address-block' : 'event-address'}>
              <img alt="nodata" src={asset('/resources/images/location-ico.svg')} />
              {!!address && <Address className="address-form" type="simple" {...address} />}
              {!address && <div className="address-notdefined">Not Defined</div>}
            </div>
          )}
        </div>

        <div className="app_download">
          <div className="entry_fairy list">
            <img alt="no-data" src={asset('/resources/images/mobile-appico.png')} className="icon" />
            <p>Entry Fairy</p>
          </div>
          <div className="app_downloadlinks">
            <a
              href="https://itunes.apple.com/us/app/entry-fairy/id900716911?mt=8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="no-data" src={asset('/resources/images/mobile-ios.png')} className="icon" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.theticketfairy.entryfairy"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="no-data" src={asset('/resources/images/mobile-android.png')} className="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )

  return isHome ? (
    renderContent()
  ) : (
    <tr className={cs}>
      <td className="eventslist-details">{renderContent()}</td>
    </tr>
  )
}

export default EventRowStaff
